<template>
  <div class="app-container">
    <div class="password-box">
      <div class="title">修改密码</div>
      <div class="notice mb10">
        <p>您当前用户密码强度较弱，请按如下要求进行密码修改（ <span>密码为6-18字符，至少包含一个大小写字母、数字和特殊符号！</span> ）</p>
      </div>
      <el-form
        ref="passwordForm"
        class="password-form"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px"
      >
        <el-form-item label="登录账号" prop="userName">
          <el-input v-model.trim="passwordForm.userName" placeholder="请输入登录账号"></el-input>
        </el-form-item>
        <el-form-item label="旧密码" prop="password">
          <el-input v-model="passwordForm.password" type="password" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword1">
          <el-input v-model="passwordForm.newPassword1" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPassword2">
          <el-input v-model="passwordForm.newPassword2" type="password" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-btn" type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getUserInfo, editUser } from '@/api/user'
import { validateStrongPassword } from '@/utils/jr-validate'

export default {
  name: 'UserEdit',
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword1) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      passwordForm: {
        id: '',
        userName: '',
        password: '',
        newPassword1: '',
        newPassword2: ''
      },
      passwordRules: {
        userName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPassword1: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validateStrongPassword, trigger: 'blur' }
        ],
        newPassword2: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      getUserInfo().then((response) => {
        const { data } = response
        this.passwordForm.id = data.id || ''
        this.passwordForm.userName = data.userName || ''
      })
    },
    handleSubmit() {
      this.$refs.passwordForm.validate((valid) => {
        if (!valid) {
          return
        }

        this.submitLoading = true
        const params = {
          user: {
            id: this.passwordForm.id,
            userName: this.passwordForm.userName,
            password: this.passwordForm.password,
            newPassword1: this.passwordForm.newPassword1,
            newPassword2: this.passwordForm.newPassword2
          },
          updateType: '4'
        }

        editUser(params)
          .then((response) => {
            const { code } = response
            if (code === 200) {
              this.$message.success('密码修改成功，请重新登录')
              this.$store.dispatch('user/resetToken').then(() => {
                this.$router.replace('/authentication')
              })
            }
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: calc(100vh - 48px);
  padding: 24px;
  background: #f2f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.password-box {
  width: 625px;
  max-width: 100%;
  padding: 36px 72px 46px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 0 20px 0 rgba(34, 108, 233, 0.3);
  box-sizing: border-box;

  .title {
    width: 280px;
    height: 56px;
    margin: 0 auto 28px;
    line-height: 56px;
    text-align: center;
    font-family: Source Han Sans CN, Microsoft YaHei, sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: #ffffff;
    background: #226ce9;
    border-radius: 28px;
  }
}

.notice {
  margin-bottom: 28px;
  padding: 12px 16px;
  border: 1px solid #d7e6ff;
  border-radius: 10px;
  background-color: #f2f8ff;
  line-height: 1.6;

  p {
    margin: 0;
    font-size: 14px;
    color: #666666;
  }

  span {
    color: #f56c6c;
  }
}

.password-form {
  ::v-deep .el-form-item {
    margin-bottom: 24px;
  }

  ::v-deep .el-form-item__label {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #333333;
  }

  ::v-deep .el-input {
    height: 60px;
  }

  ::v-deep .el-input__inner {
    height: 60px;
    padding: 12px 18px;
    font-size: 18px;
    color: #666666;
    background: rgba(132, 183, 255, 0.1);
    border: 1px solid #83b5ff;
    border-radius: 10px;
  }

  ::v-deep .el-input__inner:focus {
    border-color: #226ce9;
    box-shadow: 0 0 0 2px rgba(34, 108, 233, 0.08);
  }

  .submit-btn {
    width: 100%;
    height: 60px;
    margin-top: 4px;
    font-size: 22px;
    border: none;
    border-radius: 6px;
    box-shadow: 0 0 20px 0 rgba(63, 143, 255, 0.5);
    background-image: linear-gradient(105deg, #80b5f8 0%, #226ce9 100%);
  }
}
</style>
